import { BaseInput } from "@/components/input/CustomInputs";
import { formInterface } from "@/interface/dataInterface";
import { FC } from "react";

const VehicleFormCommon: FC<formInterface> = ({ formProp, setFormProp }) => (
  <div className="grid grid-cols-2 place-items-center gap-4">
    <BaseInput
      id="make"
      label="Make"
      value={formProp.make}
      setProp={setFormProp}
      required={false}
    />
    <BaseInput
      id="model"
      label="Model"
      value={formProp.model}
      setProp={setFormProp}
      required={false}
    />
    <BaseInput
      id="vin"
      label="VIN"
      value={formProp.vin}
      setProp={setFormProp}
      required={false}
    />
    <BaseInput
      id="license_plate"
      label="License place"
      value={formProp.license_plate}
      setProp={setFormProp}
      placeholder="XX222XX"
    />
    <BaseInput
      id="year"
      label="Year"
      value={formProp.year}
      setProp={setFormProp}
      type="number"
      placeholder="Production year"
    />
  </div>
);

export default VehicleFormCommon;
